import request from '@/utils/request'

const getAnswersById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-answers/${id}`,
    method: 'get'
  })
}

// const getAnswersByPlanId = (planId) => {
//   return request({
//     url: `${process.env.VUE_APP_BOYUAN_API}/exam-answers/by-plan-id`,
//     method: 'get',
//     params: { planId }
//   })
// }

const getAnswersPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-answers/page-list`,
    method: 'get',
    params: query
  })
}

function saveAnswers(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-answers/save`,
    method: 'post',
    data
  })
}

function saveAllAnswers(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-answers/save-all`,
    method: 'post',
    data
  })
}

export default {
  saveAnswers,
  saveAllAnswers,
  getAnswersById,
  // getAnswersByPlanId,
  getAnswersPageList
}
